import React, { useState, useEffect } from 'react';
import Button from '@/shared/Button';
import Div from '@/shared/Div';
import Paragraph from '@/shared/Paragraph';
import Cookies from '@/utils/cookie';
import {
  COOKIE_BANNER_SHOWN,
  EFL_COOKIE_ACCEPTANCE,
  EFL_COOKIE_MORE_INFO_URL,
} from '@/constants/app';
import CrossIcon from '../Icons/Cross';
import { useRouter } from 'next/router';
import Link from '@/shared/Link';

const EXCLUDED_PATHS = [
  '/amc/select-duration',
  '/ecom/checkout',
  '/ecom/cart',
  '/amc-plans',
  '/amc/cc/agent',
  '/amc/cro/agent',
  '/amc-service-plans',
  '/ecom/payment',
];

const CookieBanner = ({ isFlutterClient = false }: { isFlutterClient?: boolean }) => {
  const [showBanner, setShowBanner] = useState(false);
  const router = useRouter();

  useEffect(() => {
    const cookieAccept = Cookies.get(EFL_COOKIE_ACCEPTANCE);
    const cookieBannerShown = Cookies.get(COOKIE_BANNER_SHOWN) || '';
    if (!cookieBannerShown) Cookies.set(COOKIE_BANNER_SHOWN, 'true');
    if (!cookieAccept) {
      const timeDelay = cookieBannerShown ? 0 : 3000;
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, timeDelay);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set(EFL_COOKIE_ACCEPTANCE, 'accepted', 30);
    setShowBanner(false);
  };

  const handleDecline = () => {
    Cookies.set(EFL_COOKIE_ACCEPTANCE, 'declined', 30);
    setShowBanner(false);
  };

  if (
    !showBanner ||
    ((router.query.platform as string) || '') === 'mobile' ||
    isFlutterClient ||
    EXCLUDED_PATHS.some((path) => router.pathname.startsWith(path))
  ) {
    return null;
  }

  return (
    <Div
      className="flex items-center fixed bottom-8 bg-transparent left-s5 right-s5 bg-green z-[999] shadow-[0_0_15px_0_rgba(0,0,0,0.25)] !rounded-2xl  !md:rounded-full "
      dataTestId="cookie-banner"
    >
      <Div className="w-auto md:fixed md:w-[600px] bg-white py-s4 px-s4 md:px-s6 flex gap-s3 md:gap-s5  !bottom-8 border  md:mx-auto md:left-1/2 rounded-2xl md:rounded-full md:transform md:-translate-x-[calc(50%-32px)]">
        <Paragraph className="md:text-body-lg md:flex justify-center items-center">
          We use cookies to improve your experience.
          <Link
            className="text-extended-efbrand font-bold md:text-body-lg ml-s2"
            href={EFL_COOKIE_MORE_INFO_URL}
            dataTestId="more-info-button"
          >
            Learn more
          </Link>{' '}
        </Paragraph>

        <Button
          className="!rounded-3xl !px-s5 !py-s3"
          dataTestId="allow-button"
          onClick={handleAccept}
        >
          Allow
        </Button>

        <Button theme="none" dataTestId="close-button" onClick={handleDecline}>
          <CrossIcon />
        </Button>
      </Div>
    </Div>
  );
};

export default React.memo(CookieBanner);
